import React, { useMemo } from 'react';
import Navbar from "../components/Navbar";
import { Outlet } from "react-router-dom";

const AppLayout = () => {
  const user = useMemo(() => {
    try { return JSON.parse(localStorage.getItem("user")); } catch { return null; }
  }, []);
  const isAdmin = (user?.roleName?.toUpperCase?.() === 'ADMIN');


  return (
    <div className='flex flex-col items-center w-full no-scrollbar h-[100vh] overflow-y-scroll no-scrollbar '>
      <Navbar isAdmin={isAdmin} email={user?.email}/>
      <section className='mx-auto w-full px-8  '>
        <Outlet />
      </section>
    </div>
  );
};

export default AppLayout;
